// extracted by mini-css-extract-plugin
export var emailBlockLink = "_p3-0";